import React, { forwardRef, useContext } from 'react'
import styled, { keyframes } from 'styled-components'
import HeaderBar from './HeaderBar'
import zIndex from 'styles/tools/z-index'
import { mediaQueryUp } from 'components/utils/breakpoint'
import cn from 'clsx'
import useScrollDirection from 'hooks/useScrollDirection'
import usePrevious from 'hooks/usePrevious'
import { HeaderHeightContext } from 'contexts/HeaderStateContext'

const SlideDownAnimation = keyframes`
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
`
const SlideUpAnimation = keyframes`
  100% {
    transform: translateY(-100%);
  }
  0% {
    transform: translateY(0);
  }
`

const HeaderBarStyled = styled(HeaderBar)`
  ${mediaQueryUp.tablet} {
    position: sticky;
    top: 0;
    z-index: ${zIndex.stickyHeader};
  }

  &.slide-down, &.slide-up {
    position: sticky;
    top: 0;
    z-index: ${zIndex.stickyHeader};
  }

  // display style on scroll up
  &.slide-down {
    animation: ${SlideDownAnimation} .3s ease 0s 1 normal forwards;
    top: var(--top-offset);
    ${mediaQueryUp.tablet} {
      animation: none;
      top: 0;
    }
  }

  &.slide-up {
    animation: ${SlideUpAnimation} .3s ease 0s 1 normal forwards;
    ${mediaQueryUp.tablet} {
      animation: none;
    }
  }

  &.is-elevated {
    box-shadow: ${(props) => props.theme.shadow.bottom.small};
  }
`
interface Props {
  shouldAppearOnScrollUp?: boolean
}

const StickyHeaderBar = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { shouldAppearOnScrollUp } = props
  const direction = useScrollDirection({ tolerance: 10 })
  const previousDirection = usePrevious(direction)
  const { heights } = useContext(HeaderHeightContext)

  return <HeaderBarStyled
    ref={ref}
    className={cn({
      'is-elevated': shouldAppearOnScrollUp,
      'slide-down': (shouldAppearOnScrollUp && direction === 'up') || (previousDirection === 'up' && direction === 'up'),
      'slide-up': shouldAppearOnScrollUp && direction === 'down' && previousDirection === 'up',
    })}
    style={{ ['--top-offset' as string]: `${heights.siteStickyBanner}px` }}
  />
})

export default StickyHeaderBar
